import React from 'react'
import { Group, LockOpen, UserPlus, DollarSign, Building2 } from 'lucide-react'
import { useAppTheme, Text } from '@workwhile/ui'
import { AccordionCard } from 'components/AccordionCard'
import { FlexibleInfoTable } from './FlexibleInfoTable'
import { usePositionDetailContextValue } from '../context/PositionDetailProvider'

export const GeneralDetails = () => {
  const { space } = useAppTheme()
  const {
    state: {
      company,
      clockInCodeEnabled,
      clockOutCodeEnabled,
      allowAutocushion,
      isTipEligible,
      bundling,
    },
  } = usePositionDetailContextValue()

  return (
    <AccordionCard
      title="General details"
      size="small"
      contentWrapperProps={{
        display: 'flex',
        flexDirection: 'column',
        gap: space[2],
      }}
    >
      <FlexibleInfoTable Icon={Building2}>
        <Text>
          {company.name} ({company.id})
        </Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={Group}>
        <Text fontSize={2}>Bundling: {bundling ?? '-'}</Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={LockOpen}>
        <Text fontSize={2}>
          Clock in code: {clockInCodeEnabled ? 'Enabled' : 'Disabled'}
        </Text>
        <Text fontSize={2}>
          Clock out code: {clockOutCodeEnabled ? 'Enabled' : 'Disabled'}
        </Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={UserPlus}>
        <Text fontSize={2}>
          Autocushion: {allowAutocushion ? 'Enabled' : 'Disabled'}
        </Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={DollarSign}>
        <Text fontSize={2}>Tip: {isTipEligible ? 'Enabled' : 'Disabled'}</Text>
      </FlexibleInfoTable>
    </AccordionCard>
  )
}
